import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getUnreadNotificationCount } from '../lib/supabase'
import './NotificationButton.css'

export default function NotificationButton({ userId, className = '' }) {
  const navigate = useNavigate()
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    let cancelled = false
    let timer

    const load = async () => {
      if (!userId) return
      try {
        const count = await getUnreadNotificationCount(userId)
        if (!cancelled) setUnreadCount(count)
      } catch (e) {
        console.error('Failed to load notification count:', e)
      }
    }

    load()
    if (userId) {
      timer = setInterval(load, 30000)
    }

    return () => {
      cancelled = true
      if (timer) clearInterval(timer)
    }
  }, [userId])

  return (
    <button
      type="button"
      className={`notif-btn ${className}`.trim()}
      onClick={() => navigate('/notifications')}
      title="Notifications"
    >
      <span className="notif-btn-icon">◌</span>
      <span className="notif-btn-label">Notifications</span>
      {unreadCount > 0 && (
        <span className="notif-btn-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
      )}
    </button>
  )
}
